import React from "react";
import { Heading, Grid } from "@chakra-ui/react";
import WelcomeCard from "./WelcomeCard";
import LargeVideoCard from "./LargeVideoCard";
import VideoGrid from "./VideoGrid";

interface Props {
  sectionTitle?: any;
  sectionTag?: any;
  sectionTrainingContent?: any;
}

const Section: React.FC<Props> = ({sectionTitle, sectionTag, sectionTrainingContent}: Props) => {
  //console.log(sectionTitle + ' ' + ' ' + sectionTag + ' '  + sectionTrainingContent);
  //console.log(sectionTrainingContent);
  return (
    <Grid gap={4} mb={8}>
      <Heading size="md">
        {sectionTitle}
      </Heading>
      {sectionTag == "welcomesection" && (sectionTrainingContent.map((material: any, index: any): any =>
        <WelcomeCard
          videoTitle={material.fields.title}
          videoDescription={material.fields.description}
          videoLink={material.fields.externalUrl}
        />
      ))}
      {sectionTag == "coachtoolkitsection" && (sectionTrainingContent.map((material: any, index: any): any =>
        <LargeVideoCard
          videoTitle={material.fields.title}
          videoDescription={material.fields.description}
          videoLink={material.fields.externalUrl}
          videoImage={material.fields.image.fields.file.url}
       />
      ))}
      {sectionTag == "strategysection" && (
        <VideoGrid
          videos={sectionTrainingContent}
       />
      )}
    </Grid>
  );
}

export default Section;
